// extracted by mini-css-extract-plugin
export default {"logoBlockWrapper":"styles_logoBlockWrapper__+Ge4z","contentWrapper":"styles_contentWrapper__MaQ3Y"};